import { useState } from "react"
import { motion, AnimatePresence } from "framer-motion"
import { Box } from "theme-ui"
import openIcon from "./selecticon.png"
import { TableRow } from "components"
import redTick from "./redtick.png"
import greenTick from "./greentick.png"
import "react-loading-skeleton/dist/skeleton.css"
export const TransportItem = ({ index, item }: any) => {
 const [mainIndex, setMainIndex] = useState<boolean | null>(false)
 const [subIndex, setSubIndex] = useState<boolean | null>(false)
 const [innerIndex, setInnerIndex] = useState<boolean | null>(false)

 return (
  <div key={index} className="w-full mx-0 px-2.5 lg:px-0 lg:mx-2 mb-5">
   <Box bg="highlight" className=" w-full py-3 rounded-t">
    <Box
     bg="gray"
     color="text-black"
     style={{ margin: "0 auto" }}
     className="flex justify-between items-center w-[96%] rounded mx-auto px-2 py-3"
     onClick={() => {
      setMainIndex(!mainIndex)
     }}
    >
     <h1>{item?.common_information?.server_name + ": " + item?.common_information?.device_name}</h1>
     <div
      onClick={() => setMainIndex(!mainIndex)}
      className="h-6 w-6 rounded bg-dark-yellow flex items-center justify-center cursor-pointer"
     >
      <img className={`${mainIndex ? "rotate-360" : "rotate-180"}`} src={openIcon} alt="icon" />
     </div>
    </Box>
    <div>
     <AnimatePresence>
      {mainIndex && (
       <div className="">
        <Box bg="highlight" color="text-black">
         <motion.div
          initial={{ opacity: 0, height: 0 }}
          animate={{ opacity: 1, height: "auto" }}
          exit={{ opacity: 0, height: 0 }}
          transition={{ duration: 0.5, ease: "easeInOut" }}
          className={`border-b-[1.5px] border-light-gray w-full ${
           index === item?.state?.length - 1 ? "border-none pb-0" : ""
          }`}
         >
          <TableRow name={"Device Type"} value={item?.device_type} />
          <TableRow name={"Device Number"} value={item?.device_number} />
          <TableRow name={"Device Groups"} value={item?.device_groups} />
          <TableRow name={"Time Mechanism"} value={item?.time_mechanism} />
          <TableRow name={"Pt Type"} value={item?.pt_type} />
          <TableRow name={"Manufacturer"} value={item?.manufacturer} />
          <TableRow name={"Traffic Controller"} value={item?.traffic_controller} />
         </motion.div>
        </Box>
       </div>
      )}
     </AnimatePresence>
    </div>
   </Box>

   <Box bg="highlight" className=" w-full py-3">
    <Box
     bg="gray"
     color="text-black"
     style={{ margin: "0 auto" }}
     className="flex justify-between items-center w-[96%] rounded mx-auto px-2 py-3"
     onClick={() => {
      setSubIndex(!subIndex)
     }}
    >
     <h1>State</h1>
     <div
      onClick={() => setSubIndex(!subIndex)}
      className="h-6 w-6 rounded bg-dark-yellow flex items-center justify-center cursor-pointer"
     >
      <img className={`${subIndex ? "rotate-360" : "rotate-180"}`} src={openIcon} alt="icon" />
     </div>
    </Box>
    <div>
     <AnimatePresence>
      {subIndex && (
       <div className="">
        <Box bg="highlight" color="text-black">
         <motion.div
          initial={{ opacity: 0, height: 0 }}
          animate={{ opacity: 1, height: "auto" }}
          exit={{ opacity: 0, height: 0 }}
          transition={{ duration: 0.5, ease: "easeInOut" }}
          className={`border-b-[1.5px] border-light-gray w-full ${
           index === item?.state?.length - 1 ? "border-none pb-0" : ""
          }`}
         >
          <TableRow name={"State"} value={item?.state.state} />
          <TableRow
           name={"Communication"}
           value={
            item?.state.communication === "online" ? (
             <span>
              <img src={greenTick} alt="selecticontwo" />
             </span>
            ) : (
             <span>
              <img src={redTick} alt="selecticontwo" />
             </span>
            )
           }
          />
          <TableRow name={"Device State"} value={item?.state.device_state} />
          <TableRow name={"Error State"} value={item?.state.error_state} />
          <TableRow name={"Operating Mode"} value={item?.state.operating_mode} />
          <TableRow name={"Last Change"} value={item?.state.last_change} />
          <TableRow name={"Traffic Engineering"} value={item?.state.traffic_engineering} />
          <TableRow name={"Pt"} value={item?.state.pt} />
          <TableRow
           name={"Individual Traffic"}
           value={item?.state.individual_traffic}
           borderUnset={true}
          />
          <div></div>
         </motion.div>
        </Box>
       </div>
      )}
     </AnimatePresence>
    </div>
   </Box>
   <Box bg="highlight" className=" w-full py-3 rounded-b">
    <Box
     bg="gray"
     color="text-black"
     style={{ margin: "0 auto" }}
     className="flex justify-between items-center w-[96%] rounded mx-auto px-2 py-3"
     onClick={() => {
      setInnerIndex(!innerIndex)
     }}
    >
     <h1>Pt Data</h1>
     <div
      onClick={() => setInnerIndex(!innerIndex)}
      className="h-6 w-6 rounded bg-dark-yellow flex items-center justify-center cursor-pointer"
     >
      <img className={`${innerIndex ? "rotate-360" : "rotate-180"}`} src={openIcon} alt="icon" />
     </div>
    </Box>
    <div>
     <AnimatePresence>
      {innerIndex && (
       <div className="">
        <Box bg="highlight" color="text-black">
         <motion.div
          initial={{ opacity: 0, height: 0 }}
          animate={{ opacity: 1, height: "auto" }}
          exit={{ opacity: 0, height: 0 }}
          transition={{ duration: 0.5, ease: "easeInOut" }}
          className={`border-b-[1.5px] border-light-gray w-full ${
           index === item?.state?.length - 1 ? "border-none pb-0" : ""
          }`}
         >
          <TableRow name={"Data"} value={item?.pt_data?.data} borderUnset={true} />
         </motion.div>
        </Box>
       </div>
      )}
     </AnimatePresence>
    </div>
   </Box>
  </div>
 )
}
